import React from 'react'
import { Vault, findVault } from '~/modules/TrophyMemories/Infrastructure/vault'

interface UseVaultReturnType {
  data: Vault | undefined
  error: unknown | undefined
  isLoading: boolean
  isError: boolean
}

/**
 * Get id of NFTs that have been fragmented in the given collection
 */
export function useVault (nftAddress: string | undefined, nftId: string | null): UseVaultReturnType {
  const [isLoading, setIsLoading] = React.useState<boolean>(true)
  const [isError, setIsError] = React.useState<boolean>(false)
  const [error, setError] = React.useState<unknown | undefined>()
  const [data, setData] = React.useState<Vault | undefined>()

  React.useEffect(() => {
    findVault(nftAddress, nftId)
      .then((vault: Vault | undefined) => {
        setData(vault)
      })
      .catch((error: unknown) => {
        setError(error)
        setIsError(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [nftAddress, nftId])

  return { data, error, isLoading, isError }
}
